import { comparisonColors } from '../../utils/colors';
import {
    displayShortDate,
    DASH_DEFAULT,
    NA_DEFAULT
} from '../../utils/Format/Format';

export const getDaysAtPremiumMapData = (gqlResult) => {
    if (!gqlResult) return null;

    const disclaimer =
        'The above chart presents information about the difference between the daily market price for shares of the ETF and the ETF’s net asset value. The market price is determined using the midpoint of the bid/ask spread at market close (typically, 4 p.m. ET). The vertical axis of the chart shows the premium or discount expressed in basis points (bps). If the fund’s market price exceeds its NAV, it is trading at a premium and is represented by a positive value. If the fund’s market price is below the NAV, the ETF is trading at a discount and is represented by a negative value. This value is recorded daily over the time period displayed along the horizontal axis.';

    const { exchangeTradedFund } = gqlResult;
    const { name, shortName, inceptionDate, premiumDiscount } =
        exchangeTradedFund || {};
    const currentYear = premiumDiscount && premiumDiscount.currentYear;
    const previousYear = premiumDiscount && premiumDiscount.previousYear;
    const {
        asOfDate,
        daysTradedAtPremiumInPreviousYear,
        daysTradedAtDiscountInPreviousYear,
        daysTradedAtPremiumInCurrentYearQ1,
        daysTradedAtPremiumInCurrentYearQ2,
        daysTradedAtPremiumInCurrentYearQ3,
        daysTradedAtPremiumInCurrentYearQ4,
        daysTradedAtDiscountInCurrentYearQ1,
        daysTradedAtDiscountInCurrentYearQ2,
        daysTradedAtDiscountInCurrentYearQ3,
        daysTradedAtDiscountInCurrentYearQ4,
        premiumDiscountData
    } =
        premiumDiscount || {};

    const colors = comparisonColors;
    const tableHeaders = [
        ' ',
        `Calendar Year ${previousYear || NA_DEFAULT}`,
        `Q1 ${currentYear}`,
        `Q2 ${currentYear}`,
        `Q3 ${currentYear}`,
        `Q4 ${currentYear}`
    ];
    const lineData =
        premiumDiscount && premiumDiscountData && premiumDiscountData.length
            ? premiumDiscountData.map((ele) => ({
                  label: displayShortDate(ele.asOfDate),
                  headers: [name],
                  data: [ele.premiumDiscountValueBPS]
              }))
            : null;
    const rowData = [
        {
            label: 'Days traded at premium',
            values: [
                daysTradedAtPremiumInPreviousYear,
                daysTradedAtPremiumInCurrentYearQ1,
                daysTradedAtPremiumInCurrentYearQ2,
                daysTradedAtPremiumInCurrentYearQ3,
                daysTradedAtPremiumInCurrentYearQ4
            ]
        },
        {
            label: 'Days traded at discount',
            values: [
                daysTradedAtDiscountInPreviousYear,
                daysTradedAtDiscountInCurrentYearQ1,
                daysTradedAtDiscountInCurrentYearQ2,
                daysTradedAtDiscountInCurrentYearQ3,
                daysTradedAtDiscountInCurrentYearQ4
            ]
        }
    ].map((r) => ({
        ...r,
        values: r.values.map((v) => (v ? { v } : { DASH_DEFAULT }))
    }));
    const combinedTableData = {
        data: rowData,
        headers: tableHeaders
    };

    return {
        shortName,
        asOfDate,
        inceptionDate,
        colors,
        lineData,
        combinedTableData,
        disclaimer
    };
};
